export function getFaqs(){
    var settings = {
        "url": "https://faqapi.installernet.com/api/faqs?categoryid=61&includeSubcategories=true",
        "method": "GET",
        "timeout": 0
    }

    return $.ajax(settings);
}